'use strict';

/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;



/*****************
 ** WEBPACK FOOTER
 ** ./~/auth0-js/~/superagent/lib/is-object.js
 ** module id = 849
 ** module chunks = 0
 **/